const GetETypeDays = (id) => {
    switch (id) {
        case 0: { return "By One Day" }
        case 1: { return "By Multiple Days" }
    }
}

const GetEDayType = {
    EOpdType: [
        { Id: 0, Name: "By One Day" },
        { Id: 1, Name: "By Multiple Days" },
    ]
}
const EDayTypeBg = (id) => {
    switch (id) {
        case 0: return "bg-teal-400"
        case 1: return "bg-purple-400"
    }
}
export { GetETypeDays, GetEDayType, EDayTypeBg }